import React, { useEffect, useState } from 'react'
import { Typography, Button } from '@mui/material'
import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import { useTranslation } from 'react-i18next'
import { IconContainer } from 'components/atoms/Icons'
import { ReactComponent as AddNoteTakerIcon } from 'assets/images/addNoteTaker.svg'
import { ReactComponent as VideoCamAlertIcon } from 'assets/images/videoCamAlert.svg'
import { ReactComponent as AddCalendarIcon } from 'assets/images/addCalendar.svg'
import AddRoundedIcon from '@mui/icons-material/AddRounded'
import colors from 'styles/colors'
import RowStack from 'components/atoms/container/RowStack'
import { ColStack } from 'components/atoms/container/InCardStack'
import MeetingNoteTakerButton from '../MeetingNoteTakerButton'
import {
  getUpcomingEvents,
  getCalendarEvent
} from 'services/userConnectionsHelper'
import { getLocalUser } from 'utils/localStorage'
import { MY_MEETING } from 'routes/constants'
import { useNavigate } from 'react-router-dom'

const NoteTakerBanner = ({
  event,
  meetingUrl,
  setMeetingUrl,
  hasBot,
  setHasBot,
  eventEnded,
  calendarNotConnected,
  setCalendarNotConnected
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [showBanner, setShowBanner] = useState(false)
  const [nextEvent, setNextEvent] = useState(null)

  const checkShowBanner = eventToCheck => {
    const ownedEvent =
      getLocalUser().id ===
      eventToCheck?.userConnectionEvent?.userConnection?.createdByUserId

    if (ownedEvent && !eventToCheck?.isClosed && !eventToCheck?.botId) {
      setShowBanner(true)
    } else {
      setShowBanner(false)
    }
  }

  const fetchUpcomingEvent = async () => {
    const upcoming = await getUpcomingEvents(
      event?.userConnectionEvent?.userConnectionId
    )
    const nextEvent = upcoming[0]
    if (nextEvent?.id) {
      const calendarEvent = await getCalendarEvent(nextEvent?.id)
      if (calendarEvent) {
        return calendarEvent
      }
    }

    return null
  }

  useEffect(() => {
    const checkEventEnded = async () => {
      if (eventEnded && !hasBot) {
        const nextEvent = await fetchUpcomingEvent()
        if (nextEvent) {
          setNextEvent(nextEvent)
          checkShowBanner(nextEvent)
        }
      } else {
        checkShowBanner(event)
      }
    }
    checkEventEnded()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event, hasBot])

  const IconGroup = () => {
    return (
      <RowStack spacing={0} flex={1}>
        {(!meetingUrl || calendarNotConnected) && (
          <>
            <IconContainer
              icon={
                calendarNotConnected ? (
                  <AddCalendarIcon />
                ) : (
                  <VideoCamAlertIcon />
                )
              }
              size={72}
            />
            <IconContainer
              icon={<AddRoundedIcon />}
              size={24}
              style={{ color: colors.MidnightTeal300 }}
            />
          </>
        )}
        <IconContainer
          icon={<AddNoteTakerIcon />}
          size={72}
          style={{ '--path-color': colors.MidnightTeal300 }}
        />
      </RowStack>
    )
  }

  return (
    <>
      {showBanner && (
        <BoxWithBackground
          backgroundColor={eventEnded ? colors.Peach100 : colors.GoldenYellow50}
          borderRadius={2}
          padding={12}
          width={'100%'}>
          <RowStack justifyContent='space-between'>
            <RowStack
              spacing={0}
              gap={8}
              flex={1}
              sx={{
                '@media (max-width:1280px)': {
                  flexDirection: 'column',
                  '& svg': {
                    width: '56px !important',
                    height: '56px !important'
                  }
                }
              }}>
              <IconGroup />

              <ColStack spacing={0}>
                <Typography variant='h3'>
                  {t('myTeam.missingOutHeading')}
                </Typography>
                <Typography
                  variant='body1KindaSmall'
                  color={colors.MidnightTeal300}>
                  {calendarNotConnected
                    ? t('myTeam.receiveByAddingConnection')
                    : !meetingUrl
                      ? t('myTeam.receiveByAddingConferencing')
                      : t('myTeam.missingOutDescription')}
                </Typography>
              </ColStack>
            </RowStack>

            {!eventEnded ? (
              <MeetingNoteTakerButton
                event={event}
                meetingUrl={meetingUrl}
                setMeetingUrl={setMeetingUrl}
                hasBot={hasBot}
                setHasBot={setHasBot}
                calendarNotConnected={calendarNotConnected}
                setCalendarNotConnected={setCalendarNotConnected}
                buttonProps={{
                  startIcon: null,
                  variant: 'contained',
                  size: 'large'
                }}
              />
            ) : nextEvent ? (
              <Button
                onClick={() =>
                  navigate(MY_MEETING, {
                    state: {
                      userCalendarEventId: nextEvent.id,
                      openAddNoteTakerSingleMeeting: true
                    }
                  })
                }
                color='primary'>
                {t('myTeam.noteTakerToFuture')}
              </Button>
            ) : null}
          </RowStack>
        </BoxWithBackground>
      )}
    </>
  )
}

export default NoteTakerBanner
